export const Logo = ({ size = 38, withText = true }) => (
  <div className="flex items-center gap-2.5 select-none" data-testid="hive-logo">
    <img src="/logo192.png" width={size} height={size} alt="HIVEVORA logo" className="rounded-full hv-logo-glow" />
    {withText && (
      <span className="hc-logo font-display text-lg sm:text-2xl font-black tracking-[0.08em] sm:tracking-[0.12em]">HIVEVORA</span>
    )}
  </div>
);
